import { common as zhTWCommon } from './zh-TW/common';
import { home as zhTWHome } from './zh-TW/home';
import { equipment as zhTWEquipment } from './zh-TW/equipment';
import { locations as zhTWLocations } from './zh-TW/locations';
import { services as zhTWServices } from './zh-TW/services';
import { account as zhTWAccount } from './zh-TW/account';
import { about as zhTWAbout } from './zh-TW/about';
import { muvi as zhTWMuvi } from './zh-TW/muvi';
import zhTWPrepaid from './zh-TW/prepaid';

import { common as jaCommon } from './ja/common';
import { home as jaHome } from './ja/home';
import { equipment as jaEquipment } from './ja/equipment';
import { locations as jaLocations } from './ja/locations';
import { services as jaServices } from './ja/services';
import { account as jaAccount } from './ja/account';
import { about as jaAbout } from './ja/about';
import { muvi as jaMuvi } from './ja/muvi';
import jaPrepaid from './ja/prepaid';

import { common as enCommon } from './en/common';
import { home as enHome } from './en/home';
import { equipment as enEquipment } from './en/equipment';
import { locations as enLocations } from './en/locations';
import { services as enServices } from './en/services';
import { account as enAccount } from './en/account';
import { about as enAbout } from './en/about';
import { muvi as enMuvi } from './en/muvi';
import enPrepaid from './en/prepaid';

export const resources = {
  'zh-TW': {
    common: zhTWCommon,
    home: zhTWHome,
    equipment: zhTWEquipment,
    locations: zhTWLocations,
    services: zhTWServices,
    account: zhTWAccount,
    about: zhTWAbout,
    muvi: zhTWMuvi,
    prepaid: zhTWPrepaid
  },
  ja: {
    common: jaCommon,
    home: jaHome,
    equipment: jaEquipment,
    locations: jaLocations,
    services: jaServices,
    account: jaAccount,
    about: jaAbout,
    muvi: jaMuvi,
    prepaid: jaPrepaid
  },
  en: {
    common: enCommon,
    home: enHome,
    equipment: enEquipment,
    locations: enLocations,
    services: enServices,
    account: enAccount,
    about: enAbout,
    muvi: enMuvi,
    prepaid: enPrepaid
  }
};
